

document.addEventListener('DOMContentLoaded', function() {
  var popup = document.getElementById('size-chart-popup');
  var linkText = document.getElementById('stock-link-text');
  var closeBtn = document.getElementById('close-popup');
  var body = document.body;

  linkText.addEventListener('click', function() {
    popup.style.display = 'block';
    body.classList.add('no-scroll');
  });

  closeBtn.addEventListener('click', function() {
    popup.style.display = 'none';
    body.classList.remove('no-scroll');
  });

  window.addEventListener('click', function(event) {
    if (event.target == popup) {
      popup.style.display = 'none';
      body.classList.remove('no-scroll');
    }
  });
});
